import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useFetch } from '@rad/hooks';
import Skeleton from '@rad/components/utility/skeleton';
import { getConst } from '@rad/utility/http';
import { getTour } from '../../../../common/network/tour';
import { useAuth } from '../../../../hooks/useAuth';
import { isCrossCommunity } from '../_scope';
import TourWizardSeeded from './tour-wizard-seeded';
const AdminTourWizard = (props) => {
    const [auth] = useAuth();
    const crossCommunity = isCrossCommunity(auth.hasPermission);
    const [tourPromise] = useFetch(props.id === undefined ? getConst(null) : getTour(crossCommunity, props.id));
    return _jsx(_Fragment, { children: _jsx("div", { className: "container", children: props.id === undefined ? (_jsx(TourWizardSeeded, { tour: null, crossCommunity: crossCommunity })) : (_jsx(Skeleton, { promise: tourPromise, children: tour => tour === null
                    ? _jsx("p", { className: "text-muted text-center py-5 mb-0", children: "This tour is not available." })
                    : _jsx(TourWizardSeeded, { tour: tour, crossCommunity: crossCommunity }) })) }) });
};
export default AdminTourWizard;
